import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@aircall/ds";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

function AccordionBodyContent({ text }: { text: string }) {
  return (
    <div className="flex p-4">
      <p className="text-xs font-normal">{text}</p>
    </div>
  );
}

export function PlaygroundAccordion() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Basic</PlaygroundSubSectionTitle>
        <Accordion multiple defaultValue={["accordion-0"]}>
          <AccordionItem value="accordion-0">
            <AccordionTrigger>
              <p className="text-sm font-normal">accordion-0</p>
            </AccordionTrigger>
            <AccordionContent>
              <AccordionBodyContent text="Accordion 0 content" />
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="accordion-1">
            <AccordionTrigger>
              <p className="text-sm font-normal">accordion-1</p>
            </AccordionTrigger>
            <AccordionContent>
              <AccordionBodyContent text="Accordion 1 content" />
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="accordion-2">
            <AccordionTrigger>
              <p className="text-sm font-normal">accordion-2</p>
            </AccordionTrigger>
            <AccordionContent>
              <AccordionBodyContent text="Accordion 2 content" />
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
